import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {typeof line === "string" ? line : line.node}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, className = "" }) => (
  <motion.p
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay: 0.15 }}
    className={`font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-amber ${className}`}
  >
    {children}
  </motion.p>
);
